// extracted by mini-css-extract-plugin
export var createdDate = "_ka-1";
export var divider = "_ka-2";
export var headerDivider = "_ka-3";
export var messagesCard = "_ka-0";
export var messagesContainer = "_ka-6";
export var messagesContainerWrapper = "_ka-4";
export var showLeftPanelButton = "_ka-8";
export var topButtons = "_ka-7";
export var withPadding = "_ka-5";